import React from 'react';
import { soldermaskColorOptions, soldermaskSideOptions } from 'shared/data/selectOptions';
import SelectComponent from 'shared/components/SelectComponent';

const SolderMask = (props) => {
  const sideName = 'solder_sides';
  const colorName = 'solder_color';
  const {
    onChangeParameter,
    required,
    parameters,
    groupName,
    disabled,
    labelSide,
    labelColor,
    tooltipSide,
    tooltipColor,
    solderSidesOptions,
    solderColorOptions,
    locked,
  } = props;

  return (
    <div className="row">
      <div className="col-6">
        <SelectComponent
          label={labelSide}
          tooltip={tooltipSide}
          required={required}
          name={sideName}
          onChange={(e) => onChangeParameter(sideName, e.target.value)}
          options={solderSidesOptions}
          selected={parameters[sideName]}
          groupName={groupName}
          disabled={disabled}
          locked={locked} />
      </div>
      <div className="col-6">
        <SelectComponent
          required={required}
          label={labelColor}
          tooltip={tooltipColor}
          name={colorName}
          onChange={(e) => onChangeParameter(colorName, e.target.value)}
          options={solderColorOptions}
          selected={parameters[colorName]}
          groupName={groupName}
          disabled={disabled}
          locked={locked} />
      </div>
    </div>
  );
};

SolderMask.defaultProps = {
  labelSide: Spree.translations.parameters.solder_sides,
  labelColor: Spree.translations.parameters.solder_color,
  tooltipSide: Spree.helpForParameters.solder_sides,
  tooltipColor: Spree.helpForParameters.solder_color,
  solderSidesOptions: soldermaskSideOptions,
  solderColorOptions: soldermaskColorOptions,
  groupName: 'parameters',
};

export default SolderMask;
